import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=97e3f442&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=97e3f442&prod&lang=scss&scoped=true"
import style1 from "./Teachers.vue?vue&type=style&index=1&id=97e3f442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e3f442",
  null
  
)

export default component.exports